export const HOSTNAME = 'chokamatt.co.ke'